export const APP_NAME = 'Maagoud'
export const EMAIL_INFO = 'info@maagoud.qa'
export const SUPPORT_INFO = 'support@maagoud.qa'
export const CONTACT_INFO = '+974 5177 7107'
export const COPYRIGHTS_INFO = '© 2026'